const Utils = require("../Utils");

const service = {};

service.getSysInfo = () => ({
  os: Utils.getFromQueryString("sysInfo=os="), // not an error, this is the workaround
  iv: Utils.getFromQueryString("iv="),
  pn: Utils.getFromQueryString("pn="),
  jv: Utils.getFromQueryString("jv="),
  pv: Utils.getFromQueryString("pv="),
  ev: Utils.getFromQueryString("ev="),
  time_zone: Utils.getFromQueryString("time_zone="),
  utc_offset: Utils.getFromQueryString("utc_offset="),
  manufacturer: Utils.getFromQueryString("manufacturer="),
  product_name: Utils.getFromQueryString("product_name="),
  local_ip: Utils.getFromQueryString("local_ip="),
  mac: Utils.getFromQueryString("mac="),
  build_type: Utils.getFromQueryString("build_type="),
  machine_id: Utils.getFromQueryString("machine_id="),
  app_id: Utils.getFromQueryString("app_id="),
  hostname: Utils.getFromQueryString("hostname="),
  cpu: Utils.getFromQueryString("cpu="),
  sn: Utils.getFromQueryString("sn="),
  bn: Utils.getFromQueryString("bn="),
  bv: Utils.getFromQueryString("bv="),
  pushy_device_token: Utils.getFromQueryString("pushy_device_token="),
  fv: Utils.getFromQueryString("fv="),
  screen_info: Utils.getFromQueryString("screen_info="),
});

module.exports = service;
